import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { loadClientEvents } from 'src/store/actions/clientActions';
import { selectClientEvents } from 'src/store/selectors/clientSelectors';
import ClientEventsTable from './ClientEventsTable';

const ClientEvents = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const clientEvents = useSelector(selectClientEvents);

  useEffect(() => {
    dispatch(loadClientEvents(id));
  }, [dispatch, id]);

  return (
    <Box mt={3}>
      <ClientEventsTable clientEvents={clientEvents} />
    </Box>
  );
};

export default ClientEvents;
